module.exports = {"공모전 참여":"공모전 참여","공모전 작품의 태그는 9개까지 이용 가능합니다.":"공모전 작품의 태그는 9개까지 이용 가능합니다.","공모전 태그는 삭제하실 수 없습니다.":"공모전 태그는 삭제하실 수 없습니다.","공모전 참여 여부는 수정이 불가능합니다.":"공모전 참여 여부는 수정이 불가능합니다.","팬픽 작품은 공모전에 참여할 수 없습니다.":"팬픽 작품은 공모전에 참여할 수 없습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ko/event.json
// module id = 1764
// module chunks = 55